/**
 * How long the picker holds the chosen face's `celebrate` before it leaves.
 * First-impressions design §5: until the write lands *and* the beat has had
 * its time from the press, whichever is later — so a fast server still shows
 * the moment and a slow one shows "Saving…" as it did.
 */
export const CELEBRATE_MS = 600;

export function celebrationWait(pressedAt: number, completedAt: number, reduced: boolean): number {
  if (reduced) return 0;
  return Math.max(0, pressedAt + CELEBRATE_MS - completedAt);
}
